
















import { Component, Vue, Watch } from 'vue-property-decorator'
import CheckDevice from '@/helpers/CheckDevice'
import BlockUI from '@/components/BlockUI.vue'
import AuthService from './services/AuthService'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'
import Auth from '@/store/modules/Auth'
import i18n from '@/lang'
import { firebaseFCM } from '@/firebase'
import router from './router'
import Const, { FROM_DEVICE_WEB, PUSH_NOTIFICATION_NOT_IS_SEEN } from './constants'
const AuthModule = getModule(Auth, store)

@Component({ components: { BlockUI } })
export default class App extends Vue {
  public isMobile = false

  async created() {
    this.$root.$on('bv::modal::show', (bvEvent: any, modalId: string) => {
      const modalOpenCount = Number(document.body.dataset.modalOpenCount) || 0
      // Block stacking error modals when another modal is already open
      if (modalOpenCount > 0 && modalId.includes('error')) {
        bvEvent.preventDefault()
      }
    })
    this.manageLoginSession()

    // Register service work
    if ('serviceWorker' in navigator) {
      const registerSW = async () => {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
        console.log(registration);
        
        return registration
      }
      registerSW()
    }
    console.log('Notification.permission', Notification.permission);
    const messaging = firebaseFCM.messaging()
    messaging.onMessage((payload: any) => {
      console.log('message', payload);
      if (payload.data.isRead == PUSH_NOTIFICATION_NOT_IS_SEEN) {
        const notificationPush = new Notification(payload.data.title, {
          body: payload.data.body,
          icon: require('@/assets/images/logo-notification.png')
        })
        notificationPush.addEventListener('click', function (event) {
          router.push(payload.data.redirect_to)
        })
      }          
    })

    if (this.$store.state.auth.token) { 
      const deviceToken = localStorage.getItem('device_token')
      await AuthService.updateUserActiveToken(deviceToken || '')
    }
  }

@Watch('$store.state.auth.token')
  async handleTokenChange(newToken: string, oldToken: string) {
    if (newToken && oldToken && newToken !== oldToken) {
      const deviceToken = localStorage.getItem('device_token')
      await AuthService.updateUserActiveToken(deviceToken || '')
    }
  }

  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }
 
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    this.manageLoginSession()
  }

  private async handleBeforeUnload() {
    if (!this.$store.state.auth.token) return
 
    const payload = {
      access_token: this.$store.state.auth.token
    }
 
    const blob = new Blob([JSON.stringify(payload)], {
      type: 'application/json'
    })
    navigator.sendBeacon(
      `${Const.api_url}auth/delete-device-token`,
      blob
    )
  }

  @Watch('$route.name')
  watchChange() {
    if (this.$store.state.auth.token) {
      const messaging = firebaseFCM.messaging()
      if (Notification.permission === 'granted') {
        messaging.getToken({ vapidKey: process.env.VUE_APP_FIREBASE_VALID_KEY }).then((token: any) => {
          if (token) {
            // Send the token to your server and update the UI if necessary
            if (token != sessionStorage.getItem('device_token')) {
              let params = {
                token: token,
                from_device: FROM_DEVICE_WEB
              }
              AuthService.updateDeviceToken(params)
                .then(response => {
                  sessionStorage.setItem('device_token', token)
                  localStorage.setItem('device_token', token)
                  localStorage.setItem('user_logged_id', this.$store.state.userInfo.user.info.id)
                  console.log('token updated', response)
                })
                .catch((error) => {
                  console.error(`Error! ${error}`);
                })
            }
          }
        })
      }
    }
  }

  async logout() {
    let params = {
      token: sessionStorage.getItem('device_token')
    }
    if (params.token) {
      setTimeout(() => {
        AuthService.resetTotalNotification(params)
          .then(async (response) => {
            if (response.status === 200) {
              console.log('response.message: ', response.data.message);
              
              await AuthService.logout(params)
                .then(res => {
                  AuthModule.SET_TOKEN_NULL()
                  i18n.locale = 'ja'
                  if (res.status === 200) {
                    this.$router.push({ name: 'login' })
                    sessionStorage.clear()
                    localStorage.clear()
                  }
                })
                .catch(err => {
                  if (err) {
                    this.$router.push({ name: 'home' })
                  }
                })
            }
        })
      }, 3000)
    } else {
      await AuthService.logout(params)
        .then(res => {
          AuthModule.SET_TOKEN_NULL()
          i18n.locale = 'ja'
          if (res.status === 200) {
            this.$router.push({ name: 'login' })
            sessionStorage.clear()
            localStorage.clear()
          }
        })
        .catch(err => {
          if (err) {
            this.$router.push({ name: 'home' })
          }
        })
    }
  }

  updated() {
    let appHeight = (this.$refs.app as any).clientHeight
    let windowHeight = window.innerHeight
    this.isMobile = CheckDevice.isMobile() === true
    if (appHeight > windowHeight && !this.isMobile) {
      document.body.classList.add('body-scroll-pc')
    } else {
      document.body.classList.remove('body-scroll-pc')
    }
  }

  manageLoginSession() {
    // let totalTabs: number
    // totalTabs = Number(localStorage.getItem('count'))

    const greetCount = (e: any) => {
      let sessionStorage_transfer = (event: any) => {
        if (!event) {
          event = window.event
        } // ie suq
        if (!event.newValue) return // do nothing if no value to work with
        if (event.key == 'getSessionStorage') {
          // another tab asked for the sessionStorage -> send it
          localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage))
          // the other tab should now have it, so we're done with it.
          setTimeout(() => localStorage.removeItem('sessionStorage'), 100) // <- could do short timeout as well.
        } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
          // another tab sent data <- get it
          let data = JSON.parse(event.newValue)
          for (let key in data) {
            sessionStorage.setItem(key, data[key])
          }
        }
      }

      // listen for changes to localStorage
      globalThis.addEventListener('storage', sessionStorage_transfer, false)

      // Ask other tabs for session storage (this is ONLY to trigger event)
      if (!sessionStorage.length) {
        localStorage.setItem('getSessionStorage', 'foobar')
        localStorage.removeItem('getSessionStorage')
      }

      
    }

    if (CheckDevice.isMobile()) {
      window.onpageshow = greetCount
      // window.onpagehide = disCount
    } else {
      window.onload = greetCount
      // window.onbeforeunload = disCount
    }
  }
}
